import { useI18n } from 'vue-i18n';
import daDk from '@/locales/da-DK.json';
import deAt from '@/locales/de-AT.json';
import deCh from '@/locales/de-CH.json';
import enGb from '@/locales/en-GB.json';
import enUs from '@/locales/en-US.json';
import esEs from '@/locales/es-ES.json';
import esMX from '@/locales/es-MX.json';
import fiFi from '@/locales/fi-FI.json';
import frFr from '@/locales/fr-FR.json';
import frCh from '@/locales/fr-CH.json';
import huHu from '@/locales/hu-HU.json';
import itIt from '@/locales/it-IT.json';
import itCh from '@/locales/it-CH.json';
import nlNl from '@/locales/nl-NL.json';
import noNo from '@/locales/no-NO.json';
import plPl from '@/locales/pl-PL.json';
import ptPt from '@/locales/pt-PT.json';
import svSe from '@/locales/sv-SE.json';
import csCZ from '@/locales/cs-CZ.json';
import deDE from '@/locales/de-DE.json';
import deLU from '@/locales/de-LU.json';
import enIE from '@/locales/en-IE.json';
import frBE from '@/locales/fr-BE.json';
import frLU from '@/locales/fr-LU.json';
import nlBE from '@/locales/nl-BE.json';
import roRO from '@/locales/ro-RO.json';
import skSK from '@/locales/sk-SK.json';
import slSI from '@/locales/sl-SI.json';
import elGR from '@/locales/el-GR.json';
import hrHR from '@/locales/hr-HR.json';

export default function useTranslations() {
    const { t: ct } = useI18n({
        messages: {
            'da-DK': daDk,
            'de-AT': deAt,
            'de-CH': deCh,
            'en-GB': enGb,
            'en-US': enUs,
            'es-ES': esEs,
            'es-MX': esMX,
            'fi-FI': fiFi,
            'fr-FR': frFr,
            'fr-CH': frCh,
            'hu-HU': huHu,
            'it-IT': itIt,
            'it-CH': itCh,
            'nl-NL': nlNl,
            'no-NO': noNo,
            'pl-PL': plPl,
            'pt-PT': ptPt,
            'sv-SE': svSe,
            'cs-CZ': csCZ,
            'de-DE': deDE,
            'de-LU': deLU,
            'en-IE': enIE,
            'fr-BE': frBE,
            'fr-LU': frLU,
            'nl-BE': nlBE,
            'ro-RO': roRO,
            'sk-SK': skSK,
            'sl-SI': slSI,
            'el-GR': elGR,
            'hr-HR': hrHR,
        },
    });

    return ct;
}
